import { OPEN_MODAL, CLOSE_MODAL } from '../actionTypes';

const initialState = {
  variant: '',
};

function handleOpen({ state, payload: { variant } }) {
  return {
    ...state,
    variant,
  };
}

function handleClose({ state }) {
  return {
    ...state,
    variant: '',
  };
}

const handlers = {
  [OPEN_MODAL]: handleOpen,
  [CLOSE_MODAL]: handleClose,
};

export default function(state, { type, ...payload }) {
  if(!state) state = initialState;
  
  const handler = handlers[type];

  if (!handler) return state;

  return handler({ state, payload });
}
